import React, { Component, useState, useEffect, useRef, useLayoutEffect } from 'react'

import { AnimatePresence, motion, useMotionValue, useTransform, animate, useScroll, useMotionValueEvent, useAnimationControls, motionValue } from "framer-motion"

import { NavLink, Link } from "react-router-dom"

import Modal from 'react-modal';

import Sidebar from '../elements/Sidebar.jsx'
import Controller from '../elements/Controller.jsx'
import MetricHeader from '../elements/MetricHeader.jsx'
import MainLayout from '../elements/MainLayout.jsx'
import SecondaryLayout from '../elements/SecondaryLayout.jsx'
import ModalManager from '../elements/ModalManager.jsx'
import SaturdayReport from '../assets/saturdayreporting/SaturdayReport.jsx'
import SaturdayReportsImport from '../assets/saturdayreporting/SaturdayReportsImport.jsx'

import ReceiveDollar from '../media/icons/icons8-receive-dollar-96.png'
import RequestMoney from '../media/icons/icons8-request-money-96.png'
import Contract from '../media/icons/icons8-contract-96.png'
import Save from '../media/icons/icons8-save-96.png'
import Delete from '../media/icons/icons8-delete-96.png'

import Button from '../elements/Button.jsx'
import Counter from '../elements/Counter.jsx'
import TextInput from '../elements/TextInput.jsx'
import Table from '../elements/Table.jsx'
import IconButton from '../elements/IconButton.jsx'
import Dropdown from '../elements/ReactSelectDropdown.jsx'

import AddSpiffeeModal from '../assets/saturdayreporting/AddSpiffeeModal.jsx'
import EditSpiffeeModal from '../assets/saturdayreporting/EditSpiffeeModal.jsx'
import AddReserveInputModal from '../assets/saturdayreporting/AddReserveInputModal.jsx'
import EditReserveInputModal from '../assets/saturdayreporting/EditReserveInputModal.jsx'
import DenyReport from '../assets/DenyConfirm.jsx'
import DeleteReport from '../assets/DeleteConfirm.jsx'

import ManageTemplate from '../assets/saturdayreporting/ManageTemplates.jsx'
import SaveTemplate from '../assets/saturdayreporting/SaveTemplate.jsx'

import Notification from '../elements/Notification.jsx'

import { useCookies } from 'react-cookie'

const Main = (props) => {

    const [refresh, setRefresh] = useState(false)
    const [reportQuantity, setReportQuantity] = useState(0);

    const refreshData = () => {
        setRefresh((refresh) => !refresh)
    }

    function getCurrentTimeFormatted() {
        const now = new Date();
  
        let hours = now.getHours();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        
        hours = hours % 12; // Convert to 12-hour format
        hours = hours ? hours : 12; // The hour '0' should be '12'
        
        const minutes = now.getMinutes().toString().padStart(2, '0');
        const seconds = now.getSeconds().toString().padStart(2, '0');
      
        return `${hours.toString().padStart(2, '0')}:${minutes}:${seconds} ${ampm}`;
    }

    const buttonList = [
        {
            name: 'Saturday Reports',
            link: '/reports/saturdayreporting',
            onClick: () => {},
        },
        {
            name: 'Approve Reports',
            link: '/reports/saturdayreportingapprove',
            onClick: () => {setManageTemplatesModal(true)},
        },
        // {
        //     name: 'Show Table Data',
        //     link: '',
        //     onClick: () => {console.log(importedSaturdayReports)},
        // },
    ]

    const headerData = [
        {
            image: ReceiveDollar,
            title: 'Weekly Gross',
            change: 7,
            total: 21750,
        },
        {
            image: RequestMoney,
            title: 'Weekly Net',
            change: 5,
            total: 12275,
        },
        {
            image: Contract,
            title: 'Weekly Contracts',
            change: 12,
            total: 24.5,
        },
        {
            image: Contract,
            title: 'Monthly Contracts',
            change: -3,
            total: 123,
        },
    ]

    const dealers2 = [
        { value: '4 Season Motors', label: '4 Season Motors' },
        { value: 'Chopper City', label: 'Chopper City' },
        { value: 'Auto Station', label: 'Auto Station' },
        { value: 'Duke City Auto LLC', label: 'Duke City Auto LLC' },
        { value: 'Pitre Buick GMC', label: 'Pitre Buick GMC' },
        { value: 'Sunset Motors', label: 'Sunset Motors' },
        { value: 'Speedy Wheels', label: 'Speedy Wheels' },
        { value: 'Elite Autos', label: 'Elite Autos' },
        { value: 'Golden Motors', label: 'Golden Motors' },
        { value: 'Thunder Auto', label: 'Thunder Auto' },
        { value: 'Cityscape Cars', label: 'Cityscape Cars' },
        { value: 'Majestic Motors', label: 'Majestic Motors' },
        { value: 'Eagle Eye Autos', label: 'Eagle Eye Autos' },
        { value: 'Sprint Auto Solutions', label: 'Sprint Auto Solutions' },
        { value: 'Grand Prix Motors', label: 'Grand Prix Motors' },
        { value: 'Royal Wheels', label: 'Royal Wheels' },
        { value: 'Pinnacle Cars', label: 'Pinnacle Cars' },
        { value: 'Prime Drive', label: 'Prime Drive' },
        { value: 'Dynamic Motors', label: 'Dynamic Motors' },
        { value: 'Precision Auto', label: 'Precision Auto' },
        { value: 'Evergreen Vehicles', label: 'Evergreen Vehicles' },
        { value: 'Blue Ribbon Autos', label: 'Blue Ribbon Autos' },
        { value: 'Safari Motors', label: 'Safari Motors' },
        { value: 'Vanguard Auto', label: 'Vanguard Auto' },
        { value: 'Velocity Motors', label: 'Velocity Motors' },
        { value: 'Omega Cars', label: 'Omega Cars' },
        { value: 'Supreme Autos', label: 'Supreme Autos' },
        { value: 'Victory Vehicles', label: 'Victory Vehicles' },
        { value: 'Zenith Motors', label: 'Zenith Motors' }
    ]

    // const DPPP = 35  //NEED TO GET DATA FROM API - importedReports[selectedThursdayReport].dealer.DPPP
    // const GAP = 0 //NEED TO GET DATA FROM API - importedReports[selectedThursdayReport].dealer.GAP
    // const flats = 0 //NEED TO GET DATA FROM API - importedReports[selectedThursdayReport].dealer.flats
    // const splitAmount = 1 //NEED TO GET DATA FROM API - importedReports[selectedThursdayReport].dealer.splitAmount

    const importedReports = [
        {
            dealer: '4 Season Motors',
            contractType: 'VSC',
            grossPerContract: 125,
            admin: 'Liberty Shield',
            quantity: 1,
            reportType: 'Verification',
            dppp: 35,
            gap: 0,
            flats: 0,
            splitAmount: 1,
            spiffees: [
                {
                    name: 'Greene',
                    amount: 6.25,
                    preSpiff: false,
                    address: 'Home',
                    ATTN: 'Chase Lauer',
                    spiffType: 'Check',
                },
            ],
            reserveInputs: [
                {
                    account: 'Apollo LSC Gap',
                    amount: 300,
                    reason: 'This is a cancellation.',
                },
            ],
        },
        {
            dealer: '4 Season Motors',
            contractType: 'VSC',
            grossPerContract: 300,
            admin: 'Liberty Shield',
            quantity: 5,
            reportType: 'Verification',
            dppp: 35,
            gap: 0,
            flats: 0,
            splitAmount: 1,
            spiffees: [
                {
                    name: 'Greene',
                    amount: 6.25,
                    preSpiff: false,
                    address: 'Home',
                    ATTN: 'Chase Lauer',
                    spiffType: 'Check',
                },
            ],
            reserveInputs: [
                {
                    account: 'Apollo LSC Gap',
                    amount: 300,
                    reason: 'This is a cancellation.',
                },
            ],
        },
        {
            dealer: '4 Season Motors',
            contractType: 'VSC',
            grossPerContract: 300,
            admin: 'Liberty Shield',
            quantity: 1,
            reportType: 'Verification',
            dppp: 35,
            gap: 0,
            flats: 0,
            splitAmount: 1,
            spiffees: [
                {
                    name: 'Greene',
                    amount: 6.25,
                    preSpiff: false,
                    address: 'Home',
                    ATTN: 'Chase Lauer',
                    spiffType: 'Check',
                },
            ],
            reserveInputs: [
                {
                    account: 'Apollo LSC Gap',
                    amount: 300,
                    reason: 'This is a cancellation.',
                },
            ],
        },
        {
            dealer: '4 Season Motors',
            contractType: 'VSC',
            grossPerContract: 300,
            admin: 'Liberty Shield',
            quantity: 1,
            reportType: 'Verification',
            dppp: 35,
            gap: 0,
            flats: 0,
            splitAmount: 1,
            spiffees: [
                {
                    name: 'Greene',
                    amount: 6.25,
                    preSpiff: false,
                    address: 'Home',
                    ATTN: 'Chase Lauer',
                    spiffType: 'Check',
                },
            ],
            reserveInputs: [
                {
                    account: 'Apollo LSC Gap',
                    amount: 300,
                    reason: 'This is a cancellation.',
                },
            ],
        },
        {
            dealer: '4 Season Motors',
            contractType: 'VSC',
            grossPerContract: 300,
            admin: 'Liberty Shield',
            quantity: 1,
            reportType: 'Verification',
            dppp: 35,
            gap: 0,
            flats: 0,
            splitAmount: 1,
            spiffees: [
                {
                    name: 'Greene',
                    amount: 6.25,
                    preSpiff: false,
                    address: 'Home',
                    ATTN: 'Chase Lauer',
                    spiffType: 'Check',
                },
            ],
            reserveInputs: [
                {
                    account: 'Apollo LSC Gap',
                    amount: 300,
                    reason: 'This is a cancellation.',
                },
            ],
        },
    ]

    const templates = [
        {
            value: 'Template 1',
            label: 'Template 1',
            name: 'Template 1',
            spiffees: [
                {
                    name: 'Greene',
                    amount: 6.25,
                    preSpiff: false,
                    address: 'Home',
                    ATTN: 'Chase Lauer',
                    spiffType: 'Check',
                },
                {
                    name: 'Greene2',
                    amount: 3003,
                    preSpiff: true,
                    address: 'Home2',
                    ATTN: 'Chase Lauer2',
                    spiffType: 'Check2',
                },
            ],
            reserveInputs: [
                {
                    account: 'Apollo LSC Gap',
                    amount: 300,
                    reason: 'This is a cancellation.',
                }
            ]
        },
        {
            value: 'Template 2',
            label: 'Template 2',
            name: 'Template 2',
            spiffees: [
                {
                    name: '2Greene',
                    amount: 6.25,
                    preSpiff: false,
                    address: '2Home',
                    ATTN: '2Chase Lauer',
                    spiffType: '2Check',
                },
                {
                    name: '2Greene2',
                    amount: 3003,
                    preSpiff: true,
                    address: '2Home2',
                    ATTN: '2Chase Lauer2',
                    spiffType: '2Check2',
                },
            ],
            reserveInputs: [
                {
                    account: '2Apollo LSC Gap',
                    amount: 300,
                    reason: '2This is a cancellation.',
                }
            ]
        },
    ]

    const [tableData, setTableData] = useState(['','','','','','',''])

    const [spiffees, setSpiffees] = useState([
        // {
        //     name: 'Greene',
        //     amount: 6.25,
        //     preSpiff: false,
        //     address: 'Home',
        //     ATTN: 'Chase Lauer',
        //     spiffType: 'Check',
        // },
        // {
        //     name: 'Greene2',
        //     amount: 3003,
        //     preSpiff: true,
        //     address: 'Home2',
        //     ATTN: 'Chase Lauer2',
        //     spiffType: 'Check2',
        // },
    ])
    const [spiffeeData, setSpiffeeData] = useState([])
    const [reserveInputs, setReserveInputs] = useState([
        // {
        //     account: 'Apollo LSC Gap',
        //     amount: 300,
        //     reason: 'This is a cancellation.',
        // },
        // {
        //     account: 'Apollo LSC Gap2',
        //     amount: 3005,
        //     reason: 'This is a cancellation.',
        // },
    ])

    const addSpiffee = (newSpiffee) => {
        setSpiffees((spiffees) => [...spiffees, newSpiffee])
    }

    const updateSpiffee = (spiffeeData, index) => {
        setSpiffees((spiffees) => spiffees.map((spiffee, indexParent) => {
            if (index === indexParent)
            {
                return spiffeeData;
            } else {return spiffee}
        }))
    }

    const deleteSpiffee = (indexParent) => {
        setSpiffees((spiffees) => spiffees.filter((spiffee, index) => indexParent !== index))
    }

    const addReserveInput = (newInput) => {
        setReserveInputs((reserveInputs) => [...reserveInputs, newInput])
    }

    const updateReserveInputs = (inputData, index) => {
        setReserveInputs((inputs) => inputs.map((input, indexParent) => {
            if (index === indexParent)
            {
                return inputData;
            } else {return input}
        }))
    }

    const deleteReserveInput = (indexParent) => {
        setReserveInputs((inputs) => inputs.filter((input, index) => indexParent !== index))
    }

    const onTableChange = (e, index) => {
        if (index === 4) //check what column the change was in, 4 in this case is the template column
        {
            templates.map((template) => {
                if (template.name === e)
                {
                    applyTemplate(template, index)
                }
            })
        }
        setTableData((tableData) => tableData.map((elementData, indexParent) => {
            if (index === indexParent)
            {
                return e;
            }
            else {return elementData}
        }))
    }

    const applyTemplate = (e, index) => {
        setSpiffees(e.spiffees)
        setReserveInputs(e.reserveInputs)
    }

    const [reportSplits, setReportSplits] = useState(
        {
            flats: 0,
            splits: 0,
            gross: 0,
            net: 0,
            spiffs: 0,
            dppp: 0,
            insideSales: 0,
            gap: 0,
            contractCount: 0,
        }
    )

    const calculateSplits = (index) => {
        if (index >= 0)
        {
            const gross = importedReports[index].grossPerContract;
            const DPPP = importedReports[index].dppp
            const GAP = importedReports[index].gap
            const flats = importedReports[index].flats 
            const splitAmount = importedReports[index].splitAmount 
            //given vs derived split
            const IS = (gross-DPPP-GAP-flats-totalSpiffees())*0.1;
            const NET = gross-DPPP-GAP-flats-totalSpiffees()-((gross-DPPP-GAP-flats-totalSpiffees())*0.1)
            const SPLITS = splitAmount === 1 ? 0:(gross-DPPP-GAP-flats-totalSpiffees()-((gross-DPPP-GAP-flats-totalSpiffees())*0.1)) / splitAmount
            setReportSplits(
                {
                    gross: gross,
                    dppp: DPPP,
                    flats: flats,
                    gap: GAP,
                    spiffs: totalSpiffees(),
                    insideSales: IS,
                    net: NET,
                    splits: SPLITS,
                    contractCount: calculateContractCount(importedReports[index].contractType, NET) * reportQuantity
                }
            )
        }
    }

    const calculateContractCount = (contractType, net) => {
        if (contractType.includes('VSC'))
        {
            return net > 25 ? 1:net/25
        }
        else 
        {
            return net/100;
        }
    }

    const checkIfZeroIssue = (splits) => {
        let totalSplits = 0
        splits.map((split) => {
            totalSplits = totalSplits + split.profit_split;
        })
        console.log(totalSplits)
        if (totalSplits > .999)
        {
            return true;
        }
        else
        {
            return false
        }
    }

    const [ccSplit, setCCSplit] = useState(0)

    useEffect(() => {
        const updateContractCount = (newCount) => {
            setReportSplits(prev => ({
                ...prev,
                contractCount: ccSplit * newCount,
            }));
        };
        updateContractCount(reportQuantity)
    },[reportQuantity])

    const selectedReport = (report, index) => {
        console.log(report, index)
        //gross, DPPP, GAP, flats, splitAmount (amount of splittees) | NEED TO IMPORT ALL DATA FROM DEALER

        //get dealers
        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");
    
        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        props.tokenSafeAPIRequest('/user/me', requestOptions, '', (result, status) => {

            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow'
            };

            setSelectedThursdayReport(index)
            //calculateSplits(index)
            let SPLITS = 0;
            let CC = 0;
            report.profit_splits.map((user, index) => {
                if (user.user_ID === result.id)
                {
                    SPLITS = user.net;
                }
            })
            report.contract_count.map((user, index) => {
                if (user.user_ID === result.id)
                {
                    setCCSplit(user.amount)
                    CC = user.amount * report.quantity;
                }
            })
            console.log(SPLITS)
            setReportSplits({
                gross: report.contract_gross,
                dppp: report.dppp_amount,
                flats: report.total_flatee_payout,
                gap: report.gap_amount,
                spiffs: report.total_spiffs_per_contract,
                insideSales: report.inside_sales_payout,
                net: report.net,
                splits: SPLITS,
                contractCount: CC,
            })
            setTableData([report.report_type, report.dealership_ID.name, report.admin_ID.name, report.contract_type + ' - ' + report.contract_subtype,'','',''])
            setReportQuantity(report.quantity)
            console.log(report.spiffs.map((spiffee, index) => {
                return {
                    id: spiffee.spiffee_ID === null ? spiffee.dealership_ID:spiffee.spiffee_ID,
                    amount: spiffee.amount,
                    address: spiffee.address,
                    ATTN: spiffee.ATTN,
                    spiffType: spiffee.spiff_type,
                    type: spiffee.spiffee_ID === null ? 1:0,
                }
            }))
            setSpiffeeData(report.spiffs.map((spiffee, index) => {
                return {
                    id: spiffee.spiffee_ID === null ? spiffee.dealership_ID:spiffee.spiffee_ID,
                    amount: spiffee.amount,
                    address: spiffee.address,
                    ATTN: spiffee.ATTN,
                    spiffType: spiffee.spiff_type,
                    type: spiffee.spiffee_ID === null ? 1:0,
                }
            }));

            let tempSpiffeeData = report.spiffs.map((spiffee, index) => {
                return {
                    id: spiffee.spiffee_ID === null ? spiffee.dealership_ID:spiffee.spiffee_ID,
                    amount: spiffee.amount,
                    address: spiffee.address,
                    ATTN: spiffee.ATTN,
                    spiffType: spiffee.spiff_type,
                    type: spiffee.spiffee_ID === null ? 1:0,
                }
            })

            let tempReserveAccountData = report.reserve_inputs.map((input, index) => {
                return {
                    account_ID: input.account_ID,
                    amount: input.amount,
                    reason: input.reason,
                }
            })

            let tokenValues = {
                refresh_token: cookies['refresh_token'],
                refresh_token_expires: cookies['refresh_token_expires'],
                access_token: cookies['access_token'],
                access_token_expires: cookies['access_token_expires'],
            }

            //get dealers
            var myHeaders = new Headers();
            myHeaders.append("Accept", "application/json");
            myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
            myHeaders.append("Content-Type", "application/json");

            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow',
            };

            let tempSpiffees = []
        
            tempSpiffeeData.map((spiffee, index) => {
                console.log(spiffee)
                //0 spiffee, 1 dealership
                props.tokenSafeAPIRequest('/spiffee/resolve/' + spiffee.id + '?t=' + spiffee.type, requestOptions, tokenValues, (result) => {
                    console.log(result)
                    tempSpiffees.push({
                        name: result,
                        amount: spiffee.amount,
                        address: spiffee.address,
                        ATTN: spiffee.ATTN,
                        spiffType: spiffee.spiff_type
                    })
                })
            })

            setSpiffees(tempSpiffees)

            let reserveAccountIDs = [];
            tempReserveAccountData.map((input, index) => {
                reserveAccountIDs.push(input.account_ID)
            })

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                redirect: 'follow',
                body: JSON.stringify(reserveAccountIDs)
            };
            
            props.tokenSafeAPIRequest('/account/bulk?basic_info=true', requestOptions, tokenValues, (result) => {
                tempReserveAccountData = tempReserveAccountData.map((tempReserveAccountData, index) => {
                    return {...tempReserveAccountData, name: result[index]}
                })
                setReserveInputs(report.reserve_inputs.map((input, index) => {
                    return {
                        account: tempReserveAccountData[index].name,
                        amount: input.amount,
                        reason: input.reason,
                    }
                }))
            })
        })
        
    }

    const clearReport = () => {
        setSpiffees([]);
        setReserveInputs([]);
        setReportQuantity(0);
        setTableData(['','','','','','',''])
        setSelectedThursdayReport(-1)
        setReportSplits(
            {
                gross: 0,
                dppp: 0,
                flats: 0,
                gap: 0,
                spiffs: 0,
                insideSales: 0,
                net: 0,
                splits: 0,
                contractCount: 0
            }
        )
    }

    const totalSpiffees = () => {
        let total = 0;
        spiffees.map((spiffee) => {
            console.log('Spiffee: ' + parseFloat(spiffee.amount))
            total = total + parseFloat(spiffee.amount)
        })
        reserveInputs.map((input) => {
            console.log('Input: ' + parseFloat(input.amount))
            total = total + parseFloat(input.amount)
        })
        console.log('Total Spiffees: ' + total)
        return total;
    }

    const [spiffeeModal, setSpiffeeModal] = useState(false)
    const [editSpiffeeModal, setEditSpiffeeModal] = useState(false)
    const [selectedSpiffee, setSelectedSpiffee] = useState(0)
    const [reserveInputModal, setReserveInputModal] = useState(false)
    const [editReserveInputModal, setEditReserveInputModal] = useState(false)
    const [selectedInput, setSelectedInput] = useState(0)
    const [selectedThursdayReport, setSelectedThursdayReport] = useState(-1);
    const [manageTemplatesModal, setManageTemplatesModal] = useState(false)
    const [saveTemplateModal, setSaveTemplateModal] = useState(false);
    const [deleteReportModal, setDeleteReportModal] = useState(false);

    const bottomButtonsInfo = [
        {
            title: 'Delete',
            backgroundColor: props.colors.warning,
            onClick: () => {setDeleteReportModal(true)}
        },
    ]

    const [cookies, setCookies] = useCookies([])

    useEffect(() => {

        let tokenValues = {
            refresh_token: cookies['refresh_token'],
            refresh_token_expires: cookies['refresh_token_expires'],
            access_token: cookies['access_token'],
            access_token_expires: cookies['access_token_expires'],
        }

        //get dealers
        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");
    
        var requestOptions = {
          method: 'GET',
          headers: myHeaders,
          redirect: 'follow'
        };
        
        let dealerIds = [];
        let adminIds = []
        props.tokenSafeAPIRequest('/report/saturday/denied?fetch_links=true', requestOptions, tokenValues, (result) => {
            console.log(result)
            setImportedSaturdayReports(result)
        })
    },[refresh])

    const [importedSaturdayReports, setImportedSaturdayReports] = useState([])

    const deleteReport = (report) => {
        let tokenValues = {
            refresh_token: cookies['refresh_token'],
            refresh_token_expires: cookies['refresh_token_expires'],
            access_token: cookies['access_token'],
            access_token_expires: cookies['access_token_expires'],
        }

        //get dealers
        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");
    
        var requestOptions = {
          method: 'DELETE',
          headers: myHeaders,
          redirect: 'follow',
          body: JSON.stringify(importedSaturdayReports[selectedThursdayReport].reportIDs)
        };

        props.tokenSafeAPIRequest('/report/saturday', requestOptions, tokenValues, (result, status) => {
            if (status === 200)
            {
                setDeleteReportModal(false)
                setNotification('Deleted Report Successfully at: ' + getCurrentTimeFormatted())
                refreshData()
                clearReport();
            } else {setNotification(props.getServerResponse(result))}
        })
    }

    const [notification, setNotification] = useState('')

    function combineSubarrays(parentArray) {
        const groupedByCode = parentArray.reduce((acc, item) => {
          // Check if this code is already in the accumulator
          if (acc[item.code]) {
            // Increment quantity
            acc[item.code].quantity += item.quantity;
            // Add the id to the reportIDs array
            acc[item.code].reportIDs.push(item.id);
          } else {
            // Create a new entry in the accumulator for this code, excluding the 'id'
            const { id, ...rest } = item;
            acc[item.code] = {
              ...rest,
              quantity: item.quantity,
              reportIDs: [id]
            };
          }
          return acc;
        }, {});
      
        // Convert the grouped object back into an array
        return Object.values(groupedByCode);
    }

    return (
        <SecondaryLayout buttonList={buttonList} headerData={headerData} colors={props.colors}>
            <Sidebar colors={props.colors} tab={0}></Sidebar>
            <Controller colors={props.colors} activeButton={false} buttonList={buttonList} title={"Denied Saturday Reporting"} tokenSafeAPIRequest={props.tokenSafeAPIRequest}></Controller>
            <MetricHeader colors={props.colors} headerData={headerData} tokenSafeAPIRequest={props.tokenSafeAPIRequest}></MetricHeader>
            <SaturdayReport default={false} bottomButtons={[]} isDisabled={true} input={false} colors={props.colors} clearReport={clearReport} setSaveTemplateModal={setSaveTemplateModal} templates={templates} onQuantityChange={(e) => setReportQuantity(e)} reportQuantity={reportQuantity} selectedThursdayReport={selectedThursdayReport} importedReports={importedSaturdayReports} reportSplits={reportSplits} onChange={onTableChange} tableData={tableData} spiffees={spiffees} reserveInputs={reserveInputs} setSpiffeeModal={setSpiffeeModal} setReserveInputModal={setReserveInputModal} editSpiffee={(index) => {setSelectedSpiffee(index); setEditSpiffeeModal(true)}} editReserveInput={(index) => {setSelectedInput(index); setEditReserveInputModal(true)}}></SaturdayReport>
            <SaturdayReportsImport colors={props.colors} setSelectedReport={setSelectedThursdayReport} selectedReport={selectedThursdayReport} onSelect={selectedReport} reports={importedSaturdayReports}></SaturdayReportsImport>
            <ModalManager colors={props.colors}>
                <AddSpiffeeModal isOpen={spiffeeModal} setIsOpen={() => setSpiffeeModal(false)} selectedThursdayReport={selectedThursdayReport} onChange={() => ''} colors={props.colors} addSpiffee={addSpiffee}></AddSpiffeeModal>
                <EditSpiffeeModal isOpen={editSpiffeeModal} setIsOpen={() => setEditSpiffeeModal(false)} selectedThursdayReport={selectedThursdayReport} onChange={() => ''} colors={props.colors} selectedSpiffee={spiffees[selectedSpiffee]} spiffeeIndex={selectedSpiffee} updateSpiffee={updateSpiffee} deleteSpiffee={deleteSpiffee}></EditSpiffeeModal>
                <AddReserveInputModal isOpen={reserveInputModal} setIsOpen={() => setReserveInputModal(false)} colors={props.colors} addReserveInput={addReserveInput}></AddReserveInputModal>
                <EditReserveInputModal isOpen={editReserveInputModal} setIsOpen={() => setEditReserveInputModal(false)} colors={props.colors} selectedInput={reserveInputs[selectedInput]} inputIndex={selectedInput} updateReserveInputs={updateReserveInputs} deleteReserveInput={deleteReserveInput}></EditReserveInputModal>
                <ManageTemplate isOpen={manageTemplatesModal} setIsOpen={() => setManageTemplatesModal(false)} templates={templates} colors={props.colors}></ManageTemplate>
                <SaveTemplate isOpen={saveTemplateModal} setIsOpen={() => setSaveTemplateModal(false)} spiffees={spiffees} reserveInputs={reserveInputs} colors={props.colors}></SaveTemplate>
                <DeleteReport onClick={deleteReport} isOpen={deleteReportModal} setIsOpen={() => setDeleteReportModal(false)} colors={props.colors}></DeleteReport>
            </ModalManager>
            <Notification colors={props.colors} message={notification}></Notification>
        </SecondaryLayout>
    )
}

export default Main
